var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 528.9h71.8c10 0 18-8 18-18V196.8c0-10-8-18-18-18H18c-10 0-18 8-18 18v314.1c0 10 8 18 18 18zm0-405.3h71.8c10 0 18-8 18-18V42c0-10-8-18-18-18H18C8 24 0 32 0 42v63.8c0 9.9 8 18 18 18zm507.7 91.7a109.3 109.3 0 0 0-44.6-32.8 161.8 161.8 0 0 0-65.2-12.9c-48.3 0-89.2 18.5-122.7 55.3-6.7 7.3-11.6 5.7-11.6-4.2v-23.9c0-10-8-18-18-18h-64.1c-10 0-18 8-18 18v314.1c0 10 8 18 18 18h71.9c9.9 0 17.9-8 17.9-18V401.7c0-45.5 2.8-76.7 8.2-93.6a77.3 77.3 0 0 1 30.5-40.7 86.4 86.4 0 0 1 50.3-15.3c14.5 0 27 3.6 37.4 10.7A59.8 59.8 0 0 1 438 293c4.6 13 7 41.4 7 85.4V511c0 10 8 18 17.9 18h71.8c10 0 18-8 18-18V333c0-31.4-2-55.6-6-72.5s-11-32-21-45.2z"}));
}

LinkedinInline.defaultProps = {"xmlSpace":"preserve","width":"50","fill":"white","height":"50","viewBox":"0 0 552.8 552.8"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
